export default __webpack_public_path__ + "static/media/Samsung.e8fc52d7.svg";